import { OpeningApplicantCardFragment } from '@src/graphql/generated';
import { hasFields } from '@src/util/object/helpers';

type OpeningVerifiedApplicantCardFragment = Extract<
  OpeningApplicantCardFragment,
  { __typename?: 'VerifiedUserApplicantType' }
>;

export function isVerifiedUserApplicantType(
  applicant: OpeningApplicantCardFragment,
): applicant is OpeningVerifiedApplicantCardFragment {
  return (
    hasFields<OpeningVerifiedApplicantCardFragment>(applicant, ['__typename']) &&
    applicant.__typename === 'VerifiedUserApplicantType'
  );
}
